import React from "react"

import SystemAndOuterLengthConfigurationInput from "components/Configurations/SystemAndOuterLengthConfigurationInput"

import {
	DispatchProductDetailPageReducer,
	ProductDetailPageReducerState,
	setSelectedOuterLength,
	setSelectedSystem,
} from "@secureo/common/reducers/productDetailPageReducer"

const SystemAndOuterLengthConfiguration = ({
	isLoading,
	dispatch,
	reducerState,
	accessToken,
}: Props) => {
	const {
		selectedSystem,
		selectedOuterLength,
		attributes: { outerLengthsBySystem, systemConfigurationToolTip },
	} = reducerState

	const onSystemChange = (selectedSystem: string) => {
		setSelectedSystem(accessToken, dispatch, reducerState, selectedSystem)
	}

	const onOuterLengthChange = (selectedOuterLength: number) => {
		setSelectedOuterLength(accessToken, dispatch, reducerState, selectedOuterLength)
	}

	return (
		<SystemAndOuterLengthConfigurationInput
			outerLengthsBySystem={outerLengthsBySystem}
			selectedSystem={selectedSystem}
			selectedOuterLength={selectedOuterLength}
			onSystemChange={onSystemChange}
			onOuterLengthChange={onOuterLengthChange}
			systemConfigurationToolTip={systemConfigurationToolTip}
			disabled={isLoading || !accessToken}
		/>
	)
}

interface Props {
	isLoading: boolean
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
	accessToken: string
}

export default SystemAndOuterLengthConfiguration
